import { render, staticRenderFns } from "./RevenueCard.vue?vue&type=template&id=76c24f35&"
import script from "./RevenueCard.vue?vue&type=script&lang=js&"
export * from "./RevenueCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RevenueCard.vue"
export default component.exports